/**
 * Šírka obsahu podľa druhu obrazovky.
 *
 * Kedysi mala každá stránka rovnakých 72 rem (max-w-6xl) a detail projektu k
 * tomu ešte 48 rem vo vnútri — doska s ticketmi tak mala na 1440 px monitore
 * štyri stĺpce po 170 px s názvami zalomenými po slovách, kým vedľa ležalo
 * prázdnych 600 px. Formulár naopak na širokom monitore utiekol do šírky, kde
 * sa riadok nedal prečítať.
 *
 * - `wide`   pracovné plochy (doska, leady, plán): takmer celá šírka,
 * - `list`   zoznamy a prehľady: pohodlná šírka na riadky s metadátami,
 * - `narrow` formuláre a čítanie: riadok, ktorý sa dá prečítať.
 */
export type PageWidth = 'wide' | 'list' | 'narrow';

export const PAGE_WIDTH_CLASS: Record<PageWidth, string> = {
  // 110 rem = 1760 px: leady (zoznam ≥ 420 px + detail ≥ 380 px s rezervou) a
  // šesť stĺpcov dosky sa zmestia, a na 2560 px monitore riadok neutečie.
  wide: 'max-w-[110rem]',
  list: 'max-w-6xl',
  narrow: 'max-w-3xl',
};

const WIDE_TABS = new Set(['tickety', 'leady']);

export const pageWidthFor = (pathname: string, search = ''): PageWidth => {
  if (/^\/projects\/[^/]+\/?$/.test(pathname)) {
    const tab = new URLSearchParams(search).get('tab');
    return tab && WIDE_TABS.has(tab) ? 'wide' : 'list';
  }
  if (pathname === '/plan' || pathname.startsWith('/plan/')) {
    return 'wide';
  }
  if (
    pathname.startsWith('/settings') ||
    pathname === '/change-password' ||
    pathname === '/export-casu'
  ) {
    return 'narrow';
  }
  return 'list';
};
